import React from 'react';
import { BookOpenIcon, FileTextIcon, GlobeIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { TrustStrip } from './TrustStrip';
import { HERO_SUB, MAIN_MOCKUP } from '../data/unstuckContent';
const INDICATORS = [{
  Icon: FileTextIcon,
  label: '100% PDF'
}, {
  Icon: ZapIcon,
  label: 'Access in 5 min'
}, {
  Icon: GlobeIcon,
  label: 'All productivity levels'
}, {
  Icon: BookOpenIcon,
  label: 'Beginner to advanced'
}];
export function Hero() {
  return <header className="w-full bg-charcoal-950" data-id="element-104" data-mp="x9upzl0fdw7s">
      <div className="mx-auto flex min-h-[100svh] max-w-6xl flex-col px-5 pb-5 pt-4 text-center lg:grid lg:min-h-0 lg:grid-cols-[1.05fr_1fr] lg:grid-rows-[auto_auto] lg:items-center lg:gap-x-14 lg:py-14 lg:text-left" data-id="element-105" data-mp="xb5tdjpyl1yd">
        <div className="lg:col-start-1 lg:row-start-1 lg:self-end" data-id="element-106" data-mp="neknkw647mth">
          <p className="text-[10px] font-semibold uppercase tracking-[0.32em] text-champagne" data-id="element-107" data-mp="3d33gb2q0p1mv">
            Redondoland™
          </p>
          <h1 className="mt-2.5 font-display text-[2.6rem] font-semibold uppercase leading-[0.95] text-ivory-50 sm:text-6xl lg:mt-4 lg:text-[5.5rem]" data-id="element-108" data-mp="384s4img5wh20">
            Unstuck
          </h1>
          <p className="mt-1.5 font-display text-[1.1rem] leading-snug text-ivory-100 sm:text-2xl lg:mt-3 lg:text-3xl" data-id="element-109" data-mp="3o5j41cky9nmv">
            Reclaim your focus. Execute what matters.{' '}
            <span className="italic text-champagne" data-id="element-110" data-mp="3e7uvnjuf8hm8">From today.</span>
          </p>
        </div>

        <img src={MAIN_MOCKUP} alt="The complete UNSTUCK system — six volumes and five strategic bonuses" className="my-2.5 min-h-0 w-full flex-1 object-contain lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:my-0 lg:h-auto" width={1080} height={1080} data-id="element-111" data-mp="30ggdtgc92mgr" />

        <div className="lg:col-start-1 lg:row-start-2 lg:self-start" data-id="element-112" data-mp="2vj7rr4nzdya8">
          <p className="mx-auto max-w-md text-[12.5px] leading-snug text-body sm:text-[15px] lg:mx-0 lg:mt-6 lg:max-w-lg lg:leading-relaxed" data-id="element-113" data-mp="2hk85g3nxxvh8">
            {HERO_SUB}
          </p>

          <ul className="mt-3 flex flex-wrap items-center justify-center gap-x-4 gap-y-1.5 text-[10px] font-medium uppercase tracking-[0.14em] text-ivory-200 sm:text-[11px] lg:mt-5 lg:justify-start" data-id="element-114" data-mp="s2joo1a4k8lm">
            {INDICATORS.map(({
            Icon,
            label
          }) => <li key={label} className="flex items-center gap-1.5" data-id="element-115" data-mp="ia5jeyju8jup">
                <Icon className="h-3 w-3 text-champagne" strokeWidth={1.75} aria-hidden="true" data-id="element-116" data-mp="degeefp1uar0" />
                {label}
              </li>)}
          </ul>

          <div className="mt-3.5 flex justify-center lg:mt-6 lg:justify-start" data-id="element-117" data-mp="15zzv3csf82dd">
            <CtaButton size="md" label="I want my UNSTUCK now →" data-id="element-118" data-mp="110wp9q4m9s4c" />
          </div>
          <TrustStrip className="mt-2.5 lg:mt-4 lg:justify-start" data-id="element-119" data-mp="x0crqlg4smho" />
        </div>
      </div>
    </header>;
}